import * as THREE from 'three'; // Create enums for different types of workers

var WORKER_TYPE = {
  DECODER_WORKER_BROTLI: 'DECODER_WORKER_BROTLI',
  DECODER_WORKER: 'DECODER_WORKER'
};
var workers = {};

function createWorker(type) {
  try {
    if (type === WORKER_TYPE.DECODER_WORKER_BROTLI) {
      return new Worker(
      /* webpackChunkName: "potree2-brotli-decoder.worker" */
      new URL('../Workers/potree2-brotli-decoder.worker.js', require('url').pathToFileURL(__filename).toString()), {
        type: 'module'
      });
    } else if (type === WORKER_TYPE.DECODER_WORKER) {
      return new Worker(
      /* webpackChunkName: "potree2-decoder.worker" */
      new URL('../Workers/potree2-decoder.worker.js', require('url').pathToFileURL(__filename).toString()), {
        type: 'module'
      });
    } else {
      throw new Error('Unknown worker type');
    }
  } catch (err) {
    console.error(err);
  }
}

function getWorker(type) {
  if (!workers[type]) {
    workers[type] = [];
  }

  if (workers[type].length === 0) {
    var _worker = createWorker(type);

    workers[type].push(_worker);
  }

  var worker = workers[type].pop();
  return worker;
}

function returnWorker(type, worker) {
  workers[type].push(worker);
}

export default {
  /** @module Potree2BinParser */

  /** Parse .bin PotreeConverter 2.0 format and convert to a THREE.BufferGeometry
   * @function parse
   * @param {ArrayBuffer} buffer - the bin buffer.
   * @param {Object} options
   * @param {string[]} options.in.pointAttributes - the point attributes information contained in metadata.js
   * @return {Promise} - a promise that resolves with a THREE.BufferGeometry.
   *
   */
  parse: function (buffer, options) {
    return new Promise(function (resolve) {
      var metadata = options["in"].source.metadata;
      var layer = options.out;
      var type = metadata.encoding === 'BROTLI' ? WORKER_TYPE.DECODER_WORKER_BROTLI : WORKER_TYPE.DECODER_WORKER;
      var worker = getWorker(type);

      worker.onmessage = function (e) {
        var data = e.data;
        var buffers = data.attributeBuffers;
        returnWorker(type, worker);
        var geometry = new THREE.BufferGeometry();
        Object.keys(buffers).forEach(function (property) {
          var buffer = buffers[property].buffer;

          if (property === 'position') {
            geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(buffer), 3));
          } else if (property === 'rgba') {
            geometry.setAttribute('color', new THREE.BufferAttribute(new Uint8Array(buffer), 4, true));
          } else if (property === 'NORMAL') {
            geometry.setAttribute('normal', new THREE.BufferAttribute(new Float32Array(buffer), 3));
          } else if (property === 'INDICES') {
            var bufferAttribute = new THREE.BufferAttribute(new Uint8Array(buffer), 4);
            bufferAttribute.normalized = true;
            geometry.setAttribute('indices', bufferAttribute);
          } else {
            var _bufferAttribute = new THREE.BufferAttribute(new Float32Array(buffer), 1);

            var batchAttribute = buffers[property].attribute;
            _bufferAttribute.potree = {
              offset: buffers[property].offset,
              scale: buffers[property].scale,
              preciseBuffer: buffers[property].preciseBuffer,
              range: batchAttribute.range
            };
            geometry.setAttribute(property, _bufferAttribute);
          }
        });
        geometry.computeBoundingBox();
        resolve({
          geometry: geometry,
          density: data.density
        });
      };

      var pointAttributes = layer.pointAttributes;
      var scale = metadata.scale;
      var box = options["in"].bbox;
      var min = layer.offset.clone().add(box.min);
      var size = box.max.clone().sub(box.min);
      var max = min.clone().add(size);
      var offset = metadata.offset;
      var numPoints = options["in"].numPoints;
      var message = {
        buffer: buffer,
        pointAttributes: pointAttributes,
        scale: scale,
        min: min,
        max: max,
        size: size,
        offset: offset,
        numPoints: numPoints
      };
      worker.postMessage(message, [message.buffer]);
    });
  }
};